import { createBrowserHistory } from "history";

const routerHistory = createBrowserHistory();
export default routerHistory;
